import { IProviderQueryParameters } from '@core/model';

/**
 * Utility class to convert PrimeNG table filters to ProviderQueryParameters DTO
 */
export class TableFilterUtility {
  /**
   * Converts PrimeNG LazyLoadEvent to IProviderQueryParameters DTO
   * @param filters - LazyLoadEvent or filter object from PrimeNG table
   * @returns IProviderQueryParameters DTO
   */
  static convertToProviderQueryParams(filters: any): IProviderQueryParameters {
    const dto: IProviderQueryParameters = {};

    if (!filters) {
      return dto;
    }

    // Handle pagination
    if (filters.first !== undefined && filters.rows !== undefined) {
      dto.pageNumber = Math.floor(filters.first / filters.rows) + 1;
      dto.pageSize = filters.rows;
    }

    // Handle sorting
    if (filters.sortField) {
      dto.sortBy = filters.sortField;
      dto.sortDirection = filters.sortOrder === 1 ? 'asc' : 'desc';
    }

    if (filters.filters && typeof filters.filters === 'object') {
      console.log('Filters received:', filters.filters); // Debug log
      
      if (filters.filters.providerName) {
        const providerNameFilter = filters.filters.providerName;
        if (providerNameFilter.value !== null && providerNameFilter.value !== undefined && providerNameFilter.value !== '') {
          dto.providerName = Array.isArray(providerNameFilter.value) 
            ? providerNameFilter.value.join(',') 
            : providerNameFilter.value;
        }
      }

      
      if (filters.filters.npi) {
        const npiFilter = filters.filters.npi;
        if (npiFilter.value !== null && npiFilter.value !== undefined && npiFilter.value !== '') {
          dto.npi = Array.isArray(npiFilter.value) 
            ? npiFilter.value.join(',')
            : npiFilter.value;
        }
      }

      if (filters.filters.taxId) {
        const taxIdFilter = filters.filters.taxId;
        if (taxIdFilter.value !== null && taxIdFilter.value !== undefined && taxIdFilter.value !== '') {
          dto.taxId = Array.isArray(taxIdFilter.value) 
            ? taxIdFilter.value.join(',')
            : taxIdFilter.value;
        }
      }

      if (filters.filters.providerAddress) {
        const addressFilter = filters.filters.providerAddress;
        if (addressFilter.value !== null && addressFilter.value !== undefined && addressFilter.value !== '') {
          dto.providerAddress = Array.isArray(addressFilter.value) 
            ? addressFilter.value.join('|')
            : addressFilter.value;
        }
      }

      if (filters.filters.isActive) {
        const activeFilter = filters.filters.isActive;
        if (activeFilter.value !== null && activeFilter.value !== undefined) {
          dto.isActive = activeFilter.value;  // Direct value, no array handling
        }
      }

      if (filters.filters.tenantName) {
        const tenantNameFilter = filters.filters.tenantName;
        if (tenantNameFilter.value !== null && tenantNameFilter.value !== undefined && tenantNameFilter.value !== '') {
          dto.tenantName = Array.isArray(tenantNameFilter.value) 
            ? tenantNameFilter.value.join(',')
            : tenantNameFilter.value;
        }
      }
    }

    return dto;
  }
  
}
